export enum FEATURES {
  EDUCATION_ADVANCED_STEP = 'educationMinMax',
  ORGANIZATION_PAYFLOW_PAYMENT = 'payflow',
  TRANSCRIPT = 'transcript',
  AUDIT = 'audit',
  VOUCHERS = 'vouchers',
  EXAM_RESULTS = 'examResults',
}
